import React from "react";

export default function Contact() {
  return (
    <div className="info-container">
      <div className="container " id="contact">
        <div className="row align-items-center">
          <div className="col-4">
            <div className="mt-5 mb-5">
              <a href="mailto:jessica.boos28@gmail.com">
                📧 jessica.boos28@gmail.com
              </a>
            </div>
            <br />
            <div className="mb-5">📞 +49 1575 7192471</div>
          </div>
          <div className="col-8 text-right mt-5 mb-5">
            <h1>Kontakt</h1>
            <br />
            Falls Sie auf der Suche nach einem engagierten und
            leidenschaftlichen Frontend-Entwickler sind, würde ich mich freuen,
            von Ihnen zu hören! Kontaktieren Sie mich gerne per E-Mail oder
            Telefon, um mögliche Chancen zu besprechen. Ich freue mich darauf,
            meine Fähigkeiten in Ihr Team einzubringen und gemeinsam großartige
            Projekte zu realisieren.
          </div>
        </div>
      </div>
    </div>
  );
}
